export type logisModel = {
  name: string;
  code: string;
};

type logisParms = {
  company: logisModel[];
};

const logisData: {
  [key: string]: logisParms;
} = require('assets/data/json/offline_deliverylogis.json');

let logisNetData: {
  [key: string]: logisParms;
};

(async () => {
  try {
    // package.json "proxy": "https://mintwk.edge.naverncp.com"
    const response = await fetch(
      'https://mintwk.edge.naverncp.com/mint-house/offline_deliverylogis.json',
      {
        cache: 'no-cache',
        mode: 'cors',
        // credentials: 'include',
        // headers: {
        //   'access-control-allow-origin': '*',
        //   'Content-type': 'application/json; charset=UTF-8',
        // },
      },
    );

    logisNetData = await response.json();
  } catch (error) {
    console.error('🆘 logis', error);
  }
})();

const convertAry = (data: any) => {
  const str = JSON.stringify(data);
  const logisList: logisModel[] = JSON.parse(str);
  return logisList;
};

export const getLogis = (): any => {
  if (!logisNetData || !logisNetData['company']) {
    if (!logisData || !logisData['company']) {
      return [];
    }
    return convertAry(logisData['company']);
  }
  return convertAry(logisNetData['company']);
};

export const getLogisByName = (code: string): any => {
  if (!logisNetData || !logisNetData['company']) {
    if (!logisData || !logisData['company']) {
      return [];
    }
    const logisList: logisModel[] = convertAry(logisData['company']);
    return logisList.find((log) => log.code === code)?.name;
  }
  const logisList: logisModel[] = convertAry(logisNetData['company']);
  return logisList.find((log) => log.code === code)?.name;
};

export const getLogisByCode = (name: string): any => {
  if (!logisNetData || !logisNetData['company']) {
    if (!logisData || !logisData['company']) {
      return [];
    }
    const logisList: logisModel[] = convertAry(logisData['company']);
    return logisList.find((log) => log.name === name)?.code;
  }
  const logisList: logisModel[] = convertAry(logisNetData['company']);
  return logisList.find((log) => log.name === name)?.code;
};
